export const COMPANY_PHONES = [
  { label: '8 800 250 57 10', href: 'tel:88002505710' },
  { label: '+7 926 692 98 99', href: 'tel:+79266929899' },
  { label: '+7 965 395 78 95', href: 'tel:+79653957895' },
  { label: '8 953 368 75 36', href: 'tel:+79533687536' }
];

export const COMPANY_EMAILS = [
  { label: 'info@teplogrand.pro', href: 'mailto:info@teplogrand.pro' }
];
